/**
 * @desc 根据二字码查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.BaseCountryResponseDto>;
export function request(secondWord: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/baseCountry/bySecondWord/${secondWord}`, {
      method: "GET",

      ...options,
    }),
  );
}
